import { render, staticRenderFns } from "./FormatListBulletedSquare.vue?vue&type=template&id=64cece03"
import script from "./FormatListBulletedSquare.vue?vue&type=script&lang=js"
export * from "./FormatListBulletedSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports